var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractInvoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38266 19.75 8.3V8.3L13.75 2.3V2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11H13.38L13.06 2H7C5.34315 2 4 3.34315 4 5V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 9 20 9 20 8.94ZM14 5.40997L16.59 7.99997H14V5.40997ZM18 19C18 19.5523 17.5523 20 17 20H7C6.44771 20 6 19.5523 6 19V4.99997C6 4.44768 6.44771 3.99997 7 3.99997H12V8.99997C12 9.55225 12.4477 9.99997 13 9.99997H18V19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractInvoke);
export default __webpack_public_path__ + "static/media/contract_invoke.161c97305701ddea962865acfbc5bf0f.svg";
export { ForwardRef as ReactComponent };